<template>
  <div class="onboarding-popup">
    <div class="popup-content">
      <img class="popup-content-xmark" src="../assets/icons/popup-close-xmark.svg" alt="popup-close-xmark" @click="$emit('xmarkClick')" />
      <div v-if="img" class="popup-content-img">
        <img :src="img" alt="welcome-popup" class="w-100" />
      </div>
      <div class="popup-content-text">
        <h4 class="mb-0">{{ h }}</h4>
        <p class="mb-0">
          {{ p }}
        </p>
      </div>
      <hr />
      <div class="popup-content-actions">
        <el-button round class="popup-content-actions-cancel" @click="$emit('cancelClick')">
          {{ cancelBtn }}
        </el-button>
        <ButtonComponent variant="accent" @click="$emit('mainClick')">
          {{ mainBtn }}
        </ButtonComponent>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
export default {
  name: 'OnboardingPopup',
  props: {
    img: {
      type: String,
      required: false,
      default: '',
    },
    h: {
      type: String,
      required: true,
    },
    p: {
      type: String,
      required: true,
    },
    mainBtn: {
      type: String,
      required: true,
    },
    cancelBtn: {
      type: String,
      required: true,
    },
  },
  emits: ['xmarkClick', 'cancelClick', 'mainClick'],
}
</script>
<style scoped lang="scss">
.onboarding-popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(3, 30, 81, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  .popup-content {
    position: relative;
    background: #ffffff;
    max-width: 600px;
    border-radius: 16px;
    &-xmark {
      position: absolute;
      top: 28px;
      right: 20px;
      cursor: pointer;
    }
    &-img {
      width: 100%;
      padding: 44px 59px 0 59px;
    }
    &-text {
      display: flex;
      flex-direction: column;
      gap: 11px;
      padding: 24px 50px;
      h4 {
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        color: #252423;
      }
      p {
        font-size: 14px;
        color: #252423;
      }
    }
    hr {
      margin: 0 32px;
      height: 2px;
      background: #252423;
      opacity: 0.02;
    }
    &-actions {
      padding: 29px 37px 23px 37px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>
